// @ts-nocheck
(function () {
  function sortPanelByPrice(panel) {
    const list = panel.querySelector('.resource-list');
    const items = [...list.querySelectorAll('.resource-list__item[data-price]')];
    items.sort((a, b) => a.dataset.price - b.dataset.price);
    items.forEach(item => list.appendChild(item));
  }

  function showPanel(panel, container) {
    container.querySelectorAll('.collection-tabs-panel').forEach(p => p.classList.add('hidden'));
    panel.classList.remove('hidden');
    sortPanelByPrice(panel);
    panel.querySelectorAll('img[loading="lazy"]').forEach(img => img.removeAttribute('loading'));
    window.dispatchEvent(new Event('resize'));
  }

  function initTabs() {
    document.querySelectorAll('.collection-tabs').forEach(tabList => {
      const sectionId = tabList.id.replace('CollectionTabs-', '');
      const container = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (!container) return;

      tabList.querySelectorAll('[role="tab"]').forEach(tab => {
        tab.addEventListener('click', e => {
          e.preventDefault();
          tabList.querySelectorAll('[role="tab"]').forEach(t => t.setAttribute('aria-selected', 'false'));
          tab.setAttribute('aria-selected', 'true');
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel) showPanel(panel, container);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initTabs();
    document.querySelectorAll('.collection-tabs-panel:not(.hidden)').forEach(sortPanelByPrice);
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initTabs);
  }
})();
